import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {Student} from "../../models/student.model";
import {UserService} from "../user/user.service";
import {CurrentUser} from "../../models/user/user.model";

export interface StudentsService {
    getAll: (tenantId: string) => angular.IPromise<Student[]>;
    getByGrade: (tenantId: string, grades: number[]) => angular.IPromise<Student[]>;
}

export interface StudentsQuery {
    fromYear: number;
    toYear: number;
}

export interface StudentsResponse {
    data: Student[];
}

const MAX_GRADE = 12;

/* @ngInject */
export function studentsService(API_URL: ApiUrl, $http: angular.IHttpService, $q: angular.IQService,
                                userService: UserService): StudentsService {

    let getURL = ( tenantId: string, grades: number[]) => {
        let date = new Date();
        date.setDate(date.getDate() + 180);
        let currentGraduationYear = date.getFullYear();

        let minGrade = Math.min.apply(Math, grades);
        let toYear = currentGraduationYear + (MAX_GRADE - minGrade);

        let maxGrade = Math.max.apply(Math, grades);
        let fromYear = currentGraduationYear + (MAX_GRADE - maxGrade);

        let studentsQuery: StudentsQuery = {
            fromYear: fromYear,
            toYear: toYear
        };

        return `/${API_URL.students}/${tenantId}?query=${JSON.stringify(studentsQuery)}`;
    };

    let makeStudentGrade = (student: Student): void => {
        let schoolYear = new Date();
        let studentClassYear = student.classYear;
        schoolYear.setDate(schoolYear.getDate() + 180);

        let calculatedGrade = MAX_GRADE - (studentClassYear - schoolYear.getFullYear());
        if(calculatedGrade > MAX_GRADE) {
            student.grade = MAX_GRADE;
        } else {
            student.grade = calculatedGrade;
        }
    };

    let filterByGrades = (students: Student[], grades: number[]): Student[] => {
        if(!grades || grades.length === 0) {
            return students;
        }

        let filteredStudents: Student[] = [];
        if(!students) {
            return filteredStudents;
        }

        students.forEach(function(student: Student) {
            makeStudentGrade(student);
            if(grades.indexOf(student.grade) >= 0) {
                filteredStudents.push(student);
            }
        });

        return filteredStudents;
    };

    return {
        getAll: (tenantId: string): angular.IPromise<Student[]> => {
            return userService.get().then((currentUser: CurrentUser) => {
                return $http.get(`${API_URL.students}/${tenantId}`)
                    .then((response: StudentsResponse) => {
                    return response.data;
                }, (errorResponse) => {
                    if (errorResponse && errorResponse.status === 404) {
                        return [];
                    } else {
                        return $q.reject(errorResponse);
                    }
                });
            });
        },
        getByGrade: (tenantId: string, grades: number[]): angular.IPromise<Student[]> => {
            return userService.get().then((currentUser: CurrentUser) => {
                return $http.get(getURL(tenantId, grades))
                    .then((response: StudentsResponse) => {
                    return filterByGrades(response.data, grades);
                }, (errorResponse) => {
                    if (errorResponse && errorResponse.status === 404) {
                        return [];
                    } else {
                        return $q.reject(errorResponse);
                    }
                });
            });
        }
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/students/students.service.ts
 **/